import $ from 'jquery';

class MaRSTenants{

  //describe and create/initiate object
  constructor() {
    setTimeout(this.LoadActiveResults(), 750);
    this.resultsDiv = $(".allTenants__Results");
    this.showButton = $(".allTenants__link");
    this.filterSelect = $(".allTenants__filter-child li");
    this.loadMoreButton = $(".allTenants__load a");
    this.screenWidth = $(window).width();
    this.events();
    this.isSpinnerVisible = false;
    this.isOverlayOpen = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
    this.body = $('body');
  }

  //events
  events() {
    this.loadMoreButton.on("click", this.getMoreResults.bind(this));
    this.filterSelect.on("click", this.filterTypeLogic.bind(this));
  }


  closeDetailsOverlay() {
    this.isOverlayOpen = false;
    $('.opened').remove();
    $('body').removeClass("body-no-scroll");
  }

  //methods (function, action...)
  filterTypeLogic(e) {
    if ($(this)) {
      let curTarget = e.currentTarget;
      let target, slug = e.target;
      target = slug.getAttribute('data-name');
      let attrType = curTarget.parentElement.getAttribute('data-pane');
      let locations = curTarget.parentElement.getAttribute('data-locations') || $(".allTenants").attr("data-locations");
      let loadCount = $(".allTenants").attr("data-count") || 12;
  

      if (target) {
        clearTimeout(this.typingTimer);
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }

        this.typingTimer = setTimeout(this.getFilterResults(attrType, target, loadCount, locations), 750);
      } else if (!target && !this.isOpened) {

        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }

        this.typingTimer = setTimeout(this.getFilterResults(attrType, target, loadCount, locations), 750);
        this.isSpinnerVisible = true;
      }
    }
  }


  getFilterResults(type, typeValue, loadCount, locations) {
    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/tenants?' + type + '=' + typeValue + (type !== 'locations' ? '&locations='+locations : '')+'&number='+loadCount+'&page=1', (results) => {
      let currentPage = results.current_page;

      this.resultsDiv.html(`
         
            ${results.tenantInfo.length ? '<div class="row allTenants__row">' : '<p>No Tenant information matches that search.</p>'}
            ${results.tenantInfo.map(item => `
               
              <a href="${item.tenant_url}" 
                class="col col-6 col-md-3 venturePartnerTab__cardlink" target="_blank" title="${item.title}" rel="nofollow">
                <img class="venturePartnerTab__logo" src="${item.tenant_logo || '/wp-content/themes/marsdd-chapter/assets/img/mars-branding/logo-placeholder.png'}" alt="${item.title}">
              </a>

          `).join('')}
          ${results.tenantInfo.length ? '</div>' : ''}
     
      `);
      this.isSpinnerVisible = false;
      typeValue ? this.loadMoreButton.attr("data-url", `${type}=${typeValue}&number=${loadCount}&page=2`) : this.loadMoreButton.attr("data-url", `${type}=${typeValue}&number=${loadCount}&page=2`);
      `${results.max_pages == currentPage || results.max_pages == 0 ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }

  LoadActiveResults() {
    let loadCount = $(".allTenants").attr("data-count") || 12;
    let locations = $(".allTenants").attr("data-locations");

    if ($(".allTenants__Results").length) {
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/tenants?term=&number='+loadCount+'&locations='+locations+'&page=1', (results) => {
        let currentPage = results.current_page;

        this.resultsDiv.html(`

          ${results.tenantInfo.length ? '<div class="row allTenants__row">' : '<p>No Tenant information matches that search.</p>'}
            ${results.tenantInfo.map(item => `
               
              <a href="${item.tenant_url}" 
                class="col col-6 col-md-3 venturePartnerTab__cardlink" target="_blank" title="${item.title}" rel="nofollow">
                <img class="venturePartnerTab__logo" src="${item.tenant_logo || '/wp-content/themes/marsdd-chapter/assets/img/mars-branding/logo-placeholder.png'}" alt="${item.title}">
              </a>

          `).join('')}
          ${results.tenantInfo.length ? '</div>' : ''}

      `);
        this.isSpinnerVisible = false;

        this.loadMoreButton.attr("data-url", `term=&number=${loadCount}&locations=${locations}&page=${parseInt(currentPage) + 1}`);
        `${(results.max_pages == currentPage || results.max_pages == 0) ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr("data-url");
    let currentType = this.loadInfo.split('=');
    let type = currentType[0];
    currentType = currentType[1].split('&');
    let currentPage = 1;

    let loadCount = $(".allTenants").attr("data-count") || 12;
    let locations = $(".allTenants").attr("data-locations");


    if (!this.isSpinnerVisible) {
      this.resultsDiv.append(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
      this.isSpinnerVisible = true;
    }

    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/tenants?' + this.loadInfo + (type !=='locations' ? '&locations='+locations:''), (results) => {
      currentPage = results.current_page;
      this.resultsDiv.append(`
   
        ${results.tenantInfo.length ? '<div class="row allTenants__row">' : '<p>No Tenant information matches that search.</p>'}
            ${results.tenantInfo.map(item => `
               
              <a href="${item.tenant_url}" 
                class="col col-6 col-md-3 venturePartnerTab__cardlink" target="_blank" title="${item.title}" rel="nofollow">
                <img class="venturePartnerTab__logo" src="${item.tenant_logo || '/wp-content/themes/marsdd-chapter/assets/img/mars-branding/logo-placeholder.png'}" alt="${item.title}">
              </a>

          `).join('')}
          ${results.tenantInfo.length ? '</div>' : ''}
       
      `);
      $('.sk-double-bounce').remove();
      this.isSpinnerVisible = false;

      this.loadMoreButton.attr("data-url", `${type}=${currentType[0]}&number=${loadCount}${type !=='locations' ? '&locations='+locations:''}&page=${parseInt(currentPage) + 1}`);
      `${results.max_pages == currentPage || results.max_pages == 0 ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }

}

export default MaRSTenants;
